import {
  faCheckCircle,
  faExclamationCircle,
  faTimesCircle
} from '@fortawesome/pro-duotone-svg-icons'

import customConfig from 'customConfig'
import { LABEL_TEXT } from '../../../constants/messages'
import { COLOR_ERROR, COLOR_SUCCESS } from '../../../constants/theme'
import { getNonNegativeNumber } from '../../../util/brand.helpers'
import { formatTicks } from '../../../util/string.helpers'
import AnimateRewards from '../../shared/animateRewards/AnimateRewards'
import Popup from '../../shared/popup/Popup'
import DisplayValue from '../../shared/text/DisplayValue'

const RedeemPointsSuccess = ({ email, onSubmit, t, redeemOption }) => {
  const isNft = redeemOption?.isNft
  return (
    <Popup
      title={t('shop.redeemed-title')}
      description={t(
        isNft
          ? t('shop.redeemed-item-desc')
          : customConfig.sentEmailForCouponCode,
        { email }
      )}
      color={COLOR_SUCCESS}
      icon={faCheckCircle}
      onFormSubmit={onSubmit}
      submitLabel={t(customConfig.receiveGiftsLabel)}
    >
      <>
        <AnimateRewards />
      </>
    </Popup>
  )
}

const RedeemPointsNoBalance = ({
  redeemOption: { name, value },
  currentUserPoints,
  tokenProfile: { name: tokenName, symbol },
  onSubmit,
  onCancel,
  t
}) => {
  return (
    <Popup
      title={t('redeem.not-enough-points', {
        pointsLabel: t(customConfig.pointsLabel)
      })}
      description={t(customConfig.needPointsForGiftCard, {
        giftCard: name,
        tokenName: tokenName
      })}
      icon={faTimesCircle}
      color={COLOR_ERROR}
      submitLabel={t(LABEL_TEXT.ENTER_CODE)}
      onFormSubmit={onSubmit}
      cancelLabel={t(customConfig.goBackLabel)}
      onCancel={onCancel}
    >
      <DisplayValue
        title={`${formatTicks(getNonNegativeNumber(value - currentUserPoints))} ${symbol}`}
      />
    </Popup>
  )
}

const RedeemPointsFailed = ({ description, onSubmit, t }) => {
  return (
    <Popup
      title={t(customConfig.oopsLabel)}
      description={description}
      icon={faExclamationCircle}
      color={COLOR_ERROR}
      submitLabel={t('common.try-again')}
      onFormSubmit={onSubmit}
    />
  )
}

export { RedeemPointsFailed, RedeemPointsNoBalance, RedeemPointsSuccess }
